  <zbp-modal-template
    modalHeader="On-Page Help - Progress Reports"
    [bodyContent]="body"
    [footerContent]="footer"
    [isScrollable]="true">

    <ng-template #body>
    <ul id="reports-modal-help-list">
      <li class="reports-modal-help-list-item">
        <span class="fw-700">Progress Reports</span> - show test scores from applicable Zaner-Bloser products.
        Tests use the following benchmark coloring indicators:
        <span class="fw-700">red = below level, yellow = on level, green = above level</span>.
        Additionally, <span class="fw-700">dark grey = in progress</span> and not completed,
        <span class="fw-700">light grey = not assigned</span> and
        <span class="fw-700">white = assigned and not started</span>.
      </li>
      <li class="reports-modal-help-list-item">
        <span class="fw-700">Class Over Time</span> - for each test, shows the number of students receiving a specific benchmark. 
        Also shows how many students are still taking the test, and how many have not yet been assigned it.
      </li>
      <li class="reports-modal-help-list-item">
        <span class="fw-700">Class Spread</span> - for a specific test, shows the scores and benchmarks of each student who has completed it. 
        Scores are listed in order of lowest to highest.
      </li>
      <li class="reports-modal-help-list-item">
        <span class="fw-700">Class Heatmap</span> - for Superkids tests only, shows the skills scores and benchmarks for each student on a specific test.
      </li>
      <li class="reports-modal-help-list-item">
        <span class="fw-700">Individual Student Report</span> - shows this student's scores and benchmarks for each test within the selected product. 
        Tests are listed in the order they appear in the program.
      </li>
    </ul>
    </ng-template>

        <ng-template #footer>
          <zbp-button-component (clickHandler)="closeModal()" label="Close" />
        </ng-template>


  </zbp-modal-template>